// lib/components/date-picker/base/base-single-picker.tsx
import classNames from "classnames";
import { jsx } from "@emotion/react/jsx-runtime";
var INPUT_ATTRIBUTES = {
  date: {
    "aria-label": "\u65E5\u4ED8",
    max: "9999-12-31"
    // maxを4桁までにしておくと、年が4桁入力された時点でフォーカスが月に移動する
  },
  "datetime-local": {
    "aria-label": "\u65E5\u6642",
    max: "9999-12-31T23:59"
  },
  month: {
    "aria-label": "\u5E74\u6708",
    max: "9999-12"
  },
  time: {
    "aria-label": "\u6642\u523B",
    max: "23:59"
  }
};
var BaseSinglePicker = ({
  inputType,
  parse,
  convert,
  isSmall,
  innerRef,
  ...props
}) => {
  const handleChange = (e) => {
    const stringValue = e.target.value === "" ? void 0 : e.target.value;
    const value = stringValue ? parse(stringValue) : void 0;
    props.onChange?.(value, e);
  };
  const handleBlur = (e) => {
    const stringValue = e.target.value === "" ? void 0 : e.target.value;
    const value = stringValue ? parse(stringValue) : void 0;
    props.onBlur?.(value, e);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      props.onChange?.(void 0, e);
    }
  };
  return /* @__PURE__ */ jsx(
    "input",
    {
      "aria-label": INPUT_ATTRIBUTES[inputType]["aria-label"],
      ...props,
      ref: innerRef,
      type: inputType,
      value: props.value ? convert(props.value) : "",
      min: props.min ? convert(props.min) : void 0,
      max: props.max ? convert(props.max) : INPUT_ATTRIBUTES[inputType].max,
      className: classNames("input", { "is-small": isSmall }, props.className),
      style: {
        width: "fit-content",
        padding: "0.4em",
        ...props.style
      },
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyDown: handleKeyDown
    }
  );
};

export {
  INPUT_ATTRIBUTES,
  BaseSinglePicker
};
